import styled from 'styled-components';
import { Icon } from './Icon';

export const StreetIcon = styled(Icon)`
    &:before {
        content: '\\e55f';
    }
`;
